export default {
  ApplicationInfo: 'ข้อมูลคำขอ',
  Game: 'เกม',
  Account: 'บัญชี',
  Server: 'เซิร์ฟเวอร์',
  CharacterName: 'ชื่อตัวละคร',
  PlatformOrderNumber: 'เลขออเดอร์แพลตฟอร์ม',
  Amount: 'ยอดเติมเงิน',
  InvoiceMethod: 'วิธีออกใบเสร็จ',
  InvoiceByTotalOrderAmount: 'ออกใบเสร็จตามยอดรวมออเดอร์',
  InvoiceByOrderAmountSeparately: 'ออกใบเสร็จตามยอดแยกออเดอร์',
  PhoneNumber: 'เบอร์โทร',
  Name: 'ชื่อ-นามสกุล',
  Address: 'ที่อยู่',
  InvoiceTitle: 'จ่าหัวใบเสร็จ',
  PersonalTitleOnlyNoCompany: 'รองรับเฉพาะจ่าหัวส่วนตัว ไม่รองรับจ่าหัวบริษัท',
  ReceivingEmail: 'อีเมลที่รับ',
  Remarks: 'หมายเหตุ',
  InputContent: 'กรอกเนื้อหา',
  ApplicationSubmittedSuccessfully: 'ส่งคำขอสำเร็จ',
  InvoiceApplicationSubmittedSuccessfully:
    'ส่งคำขอใบเสร็จของคุณสำเร็จแล้ว\r\nพนักงานจะดำเนินการภายใน 7 วันทำงาน โปรดตรวจสอบอีเมล',
  Confirm: 'ยืนยัน',
  Submit: 'ส่ง',
  ApplicationSubmissionFailed: 'ส่งคำขอล้มเหลว',
  InvoiceApplicationFailed:
    'ส่งคำขอใบเสร็จของคุณล้มเหลว โปรดลองรีเฟรชหรือติดต่อฝ่ายบริการลูกค้า',
  InvoiceApplicationSubmitted: 'ได้ส่งมอบคำขอใบเสร็จให้คุณแล้ว โปรดอย่าส่งซ้ำ',
  PleaseEnterName: 'โปรดกรอกชื่อ-นามสกุล',
  PleaseEnterAddress: 'โปรดกรอกที่อยู่',
  PleaseEnterInvoiceTitle: 'โปรดกรอกจ่าหัวใบเสร็จ',
  PleaseEnterEmail: 'โปรดกรอกอีเมลที่รับ',
  PleaseEnterRemarks: 'โปรดกรอกข้อมูลหมายเหตุ',
  NumberParsingError: 'วิเคราะห์เบอร์ผิดพลาด',
  PleaseEnterValidEmailFormat: 'โปรดกรอกอีเมลที่เป็นผล',
  IncompleteInformation: 'ข้อมูลไม่ครบ โปรดตรวจสอบ',
  ExpandAll: 'แสดงทั้งหมด'
};
